export default __webpack_public_path__ + "static/media/news2.4e596e96.mp4";